"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDataForLayout = exports.dataGenerator = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
const generateButton = (visible, isQuickBuy) => {
  const QuickBuyButtonLink = {
    data: {
      __typename: 'Product',
      productCode: '43512',
      price: {
        price: {
          currentPrice: 1
        }
      }
    }
  };
  const StandardLink = {
    title: isQuickBuy ? '' : 'SHOP',
    relativeUrl: '/',
    data: {
      // @ts-expect-error -- mock data.
      __typename: isQuickBuy ? 'Product' : 'Custom',
      productCode: '43512',
      price: {
        price: {
          currentPrice: 1
        }
      }
    }
  };
  if (visible) {
    return isQuickBuy ? QuickBuyButtonLink : StandardLink;
  }
  return null;
};
const getPlaceholderImageUrl = dimensions => `https://placehold.co/${dimensions[0]}x${dimensions[1]}`;

// eslint-disable-next-line complexity -- function for data mocking
const dataGenerator = props => {
  const {
    modules,
    layout
  } = props;
  const moduleContent = [];
  for (let i = 0; i <= modules.length; i++) {
    const {
      type,
      hasButton,
      hasQuickBuyButton,
      hasTitle,
      specificTitle,
      placeholderDimension,
      hasText,
      backgroundColor,
      backgroundStorybookColor
    } = modules[i] ?? {};
    switch (type) {
      case 'text':
        moduleContent.push({
          link: generateButton(hasButton, hasQuickBuyButton),
          content: {
            title: hasTitle ? specificTitle ?? 'Find your perfect shade with our new foundation shade finder tool, Find your perfect shade with our new foundation shade finder tool, Find your perfect shade with our new foundation shade finder tool, Find your perfect shade with our new foundation shade finder tool' : '',
            textCollection: hasText ? [{
              text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Mattis vulputate enim nulla aliquet porttitor. Massa tincidunt dui ut ornare. Amet massa vitae tortor condimentum lacinia. Aliquam etiam erat velit scelerisque in. Pellentesque dignissim enim sit amet venenatis urna cursus eget nunc. Ultrices eros in cursus turpis massa tincidunt dui ut ornare. Penatibus et magnis dis parturient montes. Blandit aliquam etiam erat velit scelerisque in dictum non. Facilisis sed odio morbi quis commodo odio aenean sed adipiscing. Commodo nulla facilisi nullam vehicula ipsum a arcu cursus vitae. Molestie nunc non blandit massa enim nec. In nibh mauris cursus mattis molestie a iaculis at erat. Morbi tincidunt ornare massa eget. Tincidunt ornare massa eget egestas purus.'
            }, {
              text: 'Morbi <b>tincidunt ornare</b> massa eget egestas purusius quam quisque id diam. At varius vel pharetra vel turpis nunc eget lorem. Habitasse platea dictumst vestibulum rhoncus. Tempor orci dapibus ultrices in iaculis. Duis at consectetur lorem donec massa sapien faucibus et molestie. Lacus suspendisse faucibus interdum posuere lorem ipsum dolor. Eu augue ut lectus arcu bibendum at. Ac ut consequat semper viverra nam libero justo.'
            }, {
              text: 'Morbi tinciduus viverra accumsan. Sed arcu non odio euismod lacinia. Risus quis varius quam quisque id diam. At varius vel pharetra vel turpis nunc eget lorem. Habitasse platea dictumst vestibulum rhoncus. Tempor orci dapibus ultrices in iaculis. Duis at consectetur lorem donec massa sapien faucibus et molestie. Lacus suspendisse faucibus interdum posuere lorem ipsum dolor. Eu augue ut lectus arcu bibendum at. Ac ut consequat semper viverra nam libero justo.'
            }] : null,
            showReadMoreOption: false,
            titleColor: _editorialFetching.EditorialBannerTitleColorEnum.Black,
            titleStorybookColor: _editorialFetching.StorybookColor.Blue100,
            titleSize: _editorialFetching.EditorialBannerTitleSizeEnum.H5,
            horizontalAlignment: _editorialFetching.HorizontalContentAlignment.Left
          },
          backgroundType: _editorialFetching.BackgroundType.None,
          backgroundVideo: null,
          backgroundImage: null,
          backgroundColor: {
            type: backgroundColor ?? _editorialFetching.ColorType.White
          },
          backgroundStorybookColor: _editorialFetching.StorybookColor.CommonWhite
        });
        break;
      case 'image':
        moduleContent.push({
          link: generateButton(hasButton, hasQuickBuyButton),
          content: {
            title: hasTitle ? specificTitle ?? 'Find your perfect shade with our new foundation shade finder tool, Find your perfect shade with our new foundation shade finder tool, Find your perfect shade with our new foundation shade finder tool, Find your perfect shade with our new foundation shade finder tool' : '',
            textCollection: null,
            showReadMoreOption: false,
            titleStorybookColor: _editorialFetching.StorybookColor.Grey900,
            titleColor: _editorialFetching.EditorialBannerTitleColorEnum.Black,
            titleSize: _editorialFetching.EditorialBannerTitleSizeEnum.H5,
            horizontalAlignment: _editorialFetching.HorizontalContentAlignment.Left
          },
          backgroundType: _editorialFetching.BackgroundType.Image,
          backgroundVideo: null,
          backgroundImage: {
            url: getPlaceholderImageUrl(placeholderDimension ?? [300, 300])
          },
          backgroundColor: {
            type: _editorialFetching.ColorType.Brown
          },
          backgroundStorybookColor: _editorialFetching.StorybookColor.Brown50
        });
        break;
      case 'headline':
        moduleContent.push({
          link: generateButton(hasButton, hasQuickBuyButton),
          content: {
            title: hasTitle ? 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Curabitur ligula sapien, pulvinar a vestibulum quis Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Curabitur ligula sapien, pulvinar a vestibulum quis' : '',
            textCollection: null,
            showReadMoreOption: false,
            titleStorybookColor: _editorialFetching.StorybookColor.Grey900,
            titleColor: _editorialFetching.EditorialBannerTitleColorEnum.Black,
            titleSize: _editorialFetching.EditorialBannerTitleSizeEnum.H5,
            horizontalAlignment: _editorialFetching.HorizontalContentAlignment.Left
          },
          backgroundType: _editorialFetching.BackgroundType.None,
          backgroundVideo: null,
          backgroundImage: null,
          backgroundColor: {
            type: backgroundColor ?? _editorialFetching.ColorType.White
          },
          backgroundStorybookColor: _editorialFetching.StorybookColor.Grey900
        });
        break;
      case 'short-text':
        moduleContent.push({
          link: generateButton(hasButton, hasQuickBuyButton),
          content: {
            title: hasTitle ? "The first cleanser I've used that doesn't dry out my skin. Very pleasant feeling of softness, efficiency, pleasant texture and aroma. It is included in my daily care. The first cleanser I've used that doesn't dry out my skin. Very pleasant feeling of softness, efficiency, pleasant texture çhe first cleanser I've used that doesn't dry out my skin. Very pleasant feeling of softness, efficiency, pleasant texture Very pleasant feeling of softness, efficiency, pleasant texture" : '',
            textCollection: hasText ? [{
              text: 'Lorem ipsum dolor sit amet, sea te munere pertinax torquatos. Cu sea odio sonet explicari, at duo dicant dolores. Tota falli fabulas ne mea, facete audire suscipiantur id nec, tincidunt definitiones ut his. Suas mustang bobek'
            }] : null,
            showReadMoreOption: false,
            titleStorybookColor: _editorialFetching.StorybookColor.Grey900,
            titleColor: _editorialFetching.EditorialBannerTitleColorEnum.Black,
            titleSize: _editorialFetching.EditorialBannerTitleSizeEnum.H5,
            horizontalAlignment: _editorialFetching.HorizontalContentAlignment.Left
          },
          backgroundType: _editorialFetching.BackgroundType.None,
          backgroundVideo: null,
          backgroundImage: null,
          backgroundColor: {
            type: backgroundColor ?? _editorialFetching.ColorType.White
          },
          backgroundStorybookColor: _editorialFetching.StorybookColor.Brown300
        });
        break;
      case 'video':
        moduleContent.push({
          link: generateButton(hasButton, hasQuickBuyButton),
          content: {
            title: hasTitle ? 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Curabitur ligula sapien, pulvinar a vestibulum quis' : '',
            textCollection: null,
            showReadMoreOption: false,
            titleStorybookColor: _editorialFetching.StorybookColor.Grey900,
            titleColor: _editorialFetching.EditorialBannerTitleColorEnum.Black,
            titleSize: _editorialFetching.EditorialBannerTitleSizeEnum.H5,
            horizontalAlignment: _editorialFetching.HorizontalContentAlignment.Left
          },
          backgroundType: _editorialFetching.BackgroundType.Video,
          backgroundVideo: {
            id: 'https://media-we-cdn.oriflame.com/productVideo/?externalMediaId=product-management-media%2f38538%2fUK%2f38538.mp4%3fversion%3d1658908043#t=0.001',
            autoplayOnScroll: true,
            playInLoop: true,
            type: _editorialFetching.VideoType.Mp4
          },
          backgroundImage: null,
          backgroundColor: {
            type: backgroundColor ?? _editorialFetching.ColorType.White
          },
          backgroundStorybookColor: _editorialFetching.StorybookColor.CommonWhite
        });
        break;
      case 'vertical-video':
        moduleContent.push({
          link: generateButton(hasButton, hasQuickBuyButton),
          content: {
            title: hasTitle ? 'Koník Filip' : '',
            caption: 'Caption (Optional)',
            textCollection: hasText ? [{
              text: 'Byl jednou jeden koník jménem Filip, který měl neobvyklou zálibu – miloval želvy. Zatímco ostatní koně trénovali skákání přes překážky a závodění, Filip trávil dny pomalým krokem za svými želvími kamarády a obdivoval jejich klidný životní styl. „To je teprve pohoda,“ říkal si, když sledoval, jak želvy hodiny přemýšlejí, jestli mají udělat další krok. Farmář ho jednou chtěl přihlásit na dostihy, ale Filip místo běhu zamířil k jezírku, kde si zrovna želvy dávaly oběd. Od té doby ho raději nechali být – stal se oficiálním želvím dohližitelem a v jeho světě nebylo kam spěchat.'
            }] : null,
            showReadMoreOption: false,
            titleStorybookColor: _editorialFetching.StorybookColor.Grey900,
            titleColor: _editorialFetching.EditorialBannerTitleColorEnum.Black,
            titleSize: _editorialFetching.EditorialBannerTitleSizeEnum.H5,
            horizontalAlignment: _editorialFetching.HorizontalContentAlignment.Left
          },
          backgroundType: _editorialFetching.BackgroundType.Video,
          backgroundVideo: {
            id: 'SPnG1asnrSA',
            autoplayOnScroll: true,
            playInLoop: true,
            type: _editorialFetching.VideoType.Youtube
          },
          backgroundImage: null,
          backgroundColor: {
            type: backgroundColor ?? _editorialFetching.ColorType.White
          },
          backgroundStorybookColor: backgroundStorybookColor ?? _editorialFetching.StorybookColor.PrimaryMain
        });
        break;
      default:
        break;
    }
  }
  return {
    __typename: 'EditorialBanner',
    layout,
    modules: moduleContent,
    id: (Math.random() * (100 - 1) + 1).toString()
  };
};
exports.dataGenerator = dataGenerator;
const getDataForLayout = layout => {
  let layoutData;
  switch (layout) {
    case _editorialFetching.EditorialBannerLayoutEnum.VerticalVideo:
      layoutData = {
        layout: _editorialFetching.EditorialBannerLayoutEnum.VerticalVideo,
        modules: [{
          vertical: 'center',
          horizontal: 'center',
          hasButton: true,
          hasQuickBuyButton: false,
          hasTitle: true,
          hasText: true,
          backgroundStorybookColor: _editorialFetching.StorybookColor.PrimaryMain,
          type: 'vertical-video'
        }]
      };
      break;
    case _editorialFetching.EditorialBannerLayoutEnum.Quote:
      layoutData = {
        layout: _editorialFetching.EditorialBannerLayoutEnum.Quote,
        modules: [{
          vertical: 'center',
          horizontal: 'center',
          type: 'short-text',
          hasButton: false,
          hasQuickBuyButton: false,
          hasTitle: true,
          hasText: false,
          backgroundStorybookColor: _editorialFetching.StorybookColor.Brown300
        }]
      };
      break;
    case _editorialFetching.EditorialBannerLayoutEnum.Video:
      layoutData = {
        layout: _editorialFetching.EditorialBannerLayoutEnum.Video,
        modules: [{
          vertical: 'bottom',
          horizontal: 'center',
          type: 'video',
          hasButton: false,
          hasQuickBuyButton: false,
          hasTitle: false,
          hasText: false
        }]
      };
      break;
    case _editorialFetching.EditorialBannerLayoutEnum.FourMedia:
      layoutData = {
        layout: _editorialFetching.EditorialBannerLayoutEnum.FourMedia,
        modules: [{
          vertical: 'bottom',
          horizontal: 'center',
          type: 'image',
          hasButton: true,
          hasQuickBuyButton: false,
          hasTitle: true,
          hasText: false,
          placeholderDimension: [400, 400]
        }, {
          vertical: 'center',
          horizontal: 'center',
          type: 'image',
          hasButton: true,
          hasQuickBuyButton: false,
          hasTitle: true,
          placeholderDimension: [400, 400]
        }, {
          vertical: 'bottom',
          horizontal: 'right',
          type: 'image',
          hasButton: true,
          hasQuickBuyButton: false,
          hasTitle: true,
          placeholderDimension: [400, 400]
        }, {
          vertical: 'bottom',
          horizontal: 'center',
          type: 'image',
          hasButton: true,
          hasQuickBuyButton: false,
          hasTitle: true,
          placeholderDimension: [400, 400]
        }]
      };
      break;
    case _editorialFetching.EditorialBannerLayoutEnum.TwoMedia:
      layoutData = {
        layout: _editorialFetching.EditorialBannerLayoutEnum.TwoMedia,
        modules: [{
          vertical: 'bottom',
          horizontal: 'center',
          type: 'image',
          hasButton: true,
          hasQuickBuyButton: false,
          specificTitle: 'Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem',
          hasTitle: true,
          hasText: false,
          placeholderDimension: [490, 650]
        }, {
          vertical: 'bottom',
          horizontal: 'center',
          type: 'image',
          hasButton: true,
          hasQuickBuyButton: false,
          specificTitle: 'Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem LoremLorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem',
          hasTitle: true,
          hasText: false,
          placeholderDimension: [490, 650]
        }]
      };
      break;
    case _editorialFetching.EditorialBannerLayoutEnum.OneMediaCenterBottomText:
      layoutData = {
        layout: _editorialFetching.EditorialBannerLayoutEnum.OneMediaCenterBottomText,
        modules: [{
          vertical: 'bottom',
          horizontal: 'center',
          type: 'image',
          hasButton: true,
          hasQuickBuyButton: false,
          hasTitle: true,
          placeholderDimension: [985, 590],
          hasText: false
        }, {
          vertical: 'bottom',
          horizontal: 'center',
          type: 'text',
          hasButton: true,
          hasQuickBuyButton: false,
          hasTitle: true,
          hasText: false
        }]
      };
      break;
    case _editorialFetching.EditorialBannerLayoutEnum.TwoMediaRightTopText:
      layoutData = {
        layout: _editorialFetching.EditorialBannerLayoutEnum.TwoMediaRightTopText,
        modules: [{
          vertical: 'bottom',
          horizontal: 'center',
          type: 'image',
          hasButton: true,
          hasQuickBuyButton: false,
          hasTitle: false,
          placeholderDimension: [360, 460]
        }, {
          vertical: 'top',
          horizontal: 'center',
          type: 'short-text',
          hasButton: false,
          hasQuickBuyButton: false,
          hasTitle: true
        }, {
          vertical: 'bottom',
          horizontal: 'center',
          type: 'image',
          hasButton: true,
          hasQuickBuyButton: false,
          hasTitle: false,
          placeholderDimension: [490, 290]
        }]
      };
      break;
    case _editorialFetching.EditorialBannerLayoutEnum.ThreeMediaRightBottomText:
      layoutData = {
        layout: _editorialFetching.EditorialBannerLayoutEnum.ThreeMediaRightBottomText,
        modules: [{
          vertical: 'bottom',
          horizontal: 'center',
          type: 'image',
          hasButton: true,
          placeholderDimension: [610, 365],
          hasQuickBuyButton: false,
          hasTitle: false
        }, {
          vertical: 'bottom',
          horizontal: 'right',
          type: 'image',
          hasButton: true,
          hasQuickBuyButton: true,
          hasTitle: false,
          placeholderDimension: [300, 300]
        }, {
          vertical: 'bottom',
          horizontal: 'right',
          type: 'image',
          hasButton: true,
          hasQuickBuyButton: true,
          hasTitle: false,
          placeholderDimension: [300, 300]
        }, {
          vertical: 'bottom',
          horizontal: 'center',
          type: 'short-text',
          hasButton: true,
          hasQuickBuyButton: false,
          hasTitle: true,
          hasText: true
        }]
      };
      break;
    case _editorialFetching.EditorialBannerLayoutEnum.OneMediaOverlayLeftText:
      layoutData = {
        layout: _editorialFetching.EditorialBannerLayoutEnum.OneMediaOverlayLeftText,
        modules: [{
          vertical: 'center',
          horizontal: 'center',
          type: 'image',
          placeholderDimension: [585, 350],
          hasButton: false,
          hasQuickBuyButton: false,
          hasTitle: false
        }, {
          vertical: 'center',
          horizontal: 'left',
          type: 'short-text',
          hasButton: true,
          hasQuickBuyButton: false,
          hasTitle: true,
          hasText: false
        }]
      };
      break;
    case _editorialFetching.EditorialBannerLayoutEnum.OneMediaOverlayRightText:
      layoutData = {
        layout: _editorialFetching.EditorialBannerLayoutEnum.OneMediaOverlayRightText,
        modules: [{
          vertical: 'center',
          horizontal: 'center',
          type: 'image',
          placeholderDimension: [600, 400],
          hasButton: false,
          hasQuickBuyButton: false,
          hasTitle: false
        }, {
          vertical: 'center',
          horizontal: 'left',
          type: 'short-text',
          hasButton: true,
          hasQuickBuyButton: false,
          hasTitle: true,
          hasText: false
        }]
      };
      break;
    case _editorialFetching.EditorialBannerLayoutEnum.OneMediaParagraphText:
      layoutData = {
        layout: _editorialFetching.EditorialBannerLayoutEnum.OneMediaParagraphText,
        modules: [{
          vertical: 'bottom',
          horizontal: 'center',
          type: 'image',
          hasQuickBuyButton: false,
          hasTitle: false,
          hasText: false,
          hasButton: false,
          placeholderDimension: [490, 650]
        }, {
          vertical: 'center',
          horizontal: 'center',
          type: 'text',
          hasQuickBuyButton: false,
          hasTitle: true,
          hasText: true,
          hasButton: true
        }]
      };
      break;
    case _editorialFetching.EditorialBannerLayoutEnum.ParagraphText:
      layoutData = {
        layout: _editorialFetching.EditorialBannerLayoutEnum.ParagraphText,
        modules: [{
          vertical: 'bottom',
          horizontal: 'center',
          type: 'text',
          hasButton: false,
          hasQuickBuyButton: false,
          hasTitle: true,
          hasText: true
        }]
      };
      break;
    case _editorialFetching.EditorialBannerLayoutEnum.Headline:
      layoutData = {
        layout: _editorialFetching.EditorialBannerLayoutEnum.Headline,
        modules: [{
          vertical: 'center',
          horizontal: 'center',
          type: 'headline',
          hasButton: true,
          hasQuickBuyButton: false,
          hasTitle: true,
          hasText: false
        }]
      };
      break;
    default:
      layoutData = {
        layout: _editorialFetching.EditorialBannerLayoutEnum.Quote,
        modules: [{
          vertical: 'center',
          horizontal: 'center',
          type: 'image',
          hasButton: false,
          hasQuickBuyButton: false,
          hasTitle: false
        }]
      };
  }
  return dataGenerator(layoutData);
};
exports.getDataForLayout = getDataForLayout;
